export default __webpack_public_path__ + "static/media/puiya-logo-qr.4e7224a8.png";